<template>
  <div class="tab-pane-section">
    <div class="tab-pane-header">
      <div class="tab-pane-header__title"> Today </div>
    </div>

    <div class="tab-pane-body">
      <div class="charts-row">
        <div class="chart-block">
          <div class="chart-block-header">
            <div class="chart-block-header__title">
              Gross volume
            </div>
            <div class="chart-block-header__value">
              $ {{ grossVolumeChart.value }}
            </div>
          </div>
          <div class="chart-block-body">
            <apexcharts
                width="100%"
                height="300px"
                :options="grossVolumeChart.options"
                :series="grossVolumeChart.series"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import VueApexCharts from 'vue-apexcharts'
  import analyticFormatData from '@/mixins/analyticFormatData'

  export default {
    name: 'PaymentChartsGross',
    mixins: [analyticFormatData],
    components: {
      apexcharts: VueApexCharts
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters({
        grossVolume: 'analytic/getGrossVolume'
      }),
      grossVolumeChart() {
        const chartOpts = {
          series: [{ name: 'Gross volume', data: [] }],
          options: {
            chart: {
              type: 'line',
              animations: { speed: 200 },
              toolbar: { show: false }
            },
            noData: {
              text: 'No succeed payments recorded for current time'
            },
            colors: ['#3366cd','#4a596ade'],
            stroke: { curve: 'straight', width: 1 },
            dataLabels: { enabled: true },
            grid: { show: false },
            legend: { show: false },
            xaxis: {
              categories: [],
              labels: { show: true },
              tooltip: { enabled: false }
            },
            yaxis: {
              labels: { show: true },
              tooltip: { enabled: false }
            },
            tooltip: {
              y: {
                formatter: value => `$ ${ Number(value) }`
              }
            }
          }
        }

        this.grossVolume.reduce((acc, next) => Number(acc.sum) + Number(next.sum), 0)
        let temp = []
        if (this.grossVolume.length) {
          chartOpts.options.xaxis.categories.push('00:00', this.date().time)

          this.grossVolume.forEach(val => temp.push(val.sum))
          chartOpts.series[0].data.push(0, temp.reduce((acc, next) => Number(acc) + Number(next), 0))
        } else {
          chartOpts.series[0].data.push(0)
          chartOpts.options.xaxis.categories.push(this.date().time)
        }


        return {
          options: chartOpts.options,
          series: chartOpts.series,
          value: !chartOpts.series[0].data[1] ? 0 : chartOpts.series[0].data[1]
        }
      }
    },
    created() {
      this.$store.dispatch('analytic/getGrossVolume')
    }
  }
</script>

<style lang="scss" scoped>
  .tab-pane-section {
    padding-bottom: 25px;

    .tab-pane-header {
      border-bottom: 1px solid #E4E7ED;

      &__title {
        margin: 10px 0;
        padding-bottom: 10px;
        font-size: 28px;
        font-weight: 600;

        @media (max-width: 550px) {
          text-align: center;
        }
      }
    }

    .tab-pane-body {
      padding-top: 10px;
      border-bottom: 1px solid #E4E7ED;

      .charts-row {
        display: flex;
        flex-direction: row;
        justify-content: center;

        .chart-block {
          width: 100%;

          &-header {
            &__title {
              padding: 10px 0 0 20px;
              font-weight: 600;
              color: #4a596ade;
            }

            &__value {
              padding-left: 20px;
              color: #3366cd;
              font-size: 21px;
              font-weight: 400;
            }
          }

          &-body {
            position: relative;

            div {
              display: flex;
              justify-content: center;
            }
          }
        }
      }
    }
  }
</style>
